import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FileService } from 'src/app/services/file.service';
import { FormServices } from 'src/app/services/form-services.service';
import { HttpService } from 'src/app/services/http.service';
import { UiServices } from 'src/app/services/ui-services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-special-requests',
  templateUrl: './special-requests.page.html',
  styleUrls: ['./special-requests.page.scss'],
})
export class SpecialRequestsPage implements OnInit {
  public buttons = [
    {
      name: 'Grupo',
      value: 'groupChoices',
    },
    {
      name: 'Opciones',
      value: 'choices',
    },
    {
      name: 'Peticiones',
      value: 'specialRequests',
    },
  ];

  public isUploading = false;
  public segmentValue = 'groupChoices';
  public editing = undefined;
  public savedForm = undefined;
  public fieldForms: any[] = undefined;
  private backParents = undefined;
  private _domainId = environment.domainId;
  private noReload = false;
  public group = [];

  constructor(
    private formSv: FormServices,
    private trSv: TranslateService,
    private httpSv: HttpService,
    private uiSv: UiServices,
    private fileSv: FileService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    const specialRequestId = this.route.snapshot.queryParamMap.get('id');
    if (specialRequestId) {
      this.setSegment('specialRequests');
    }
  }

  async setSegment(ev?) {
    this.savedForm = undefined;
    this.segmentValue = ev;
    this.editing = undefined;
    await this.getForm();
  }

  async getForm() {
    if (this.segmentValue) {
      this.fieldForms = await this.formSv.getForm(
        this.segmentValue,
        this._domainId
      );
      const parents =
        this.fieldForms.find((item) => item.fieldName === 'choiceId') ||
        undefined;
      this.backParents = { ...parents };
    }
  }

  async send(ev: FormData) {
    try {
      this.editing && ev.set('id', String(this.editing));
      this.isUploading = true;
      const res: any = await this.httpSv.itemAction(
        ev,
        this.segmentValue,
        this.editing ? 'update' : 'store'
      );
      this.isUploading = false;
      const msg = this.segmentValue !== 'choices' ? 'GRUPO' : 'ADICIONAL';
      if (this.segmentValue === 'choices') {
        await this.getForm();
      }
      const tr = this.trSv.instant(`${msg}_GUARDADO_EXITOSAMENTE`);
      await this.uiSv.showToast(tr);
      if (res.status) {
        // this.id = res.data.id;
        this.editing = undefined;
        this.formSv.clearFormSrc.next();
        this.formSv.deleteListProductSrc.next('reloadListProduct');
      }
    } catch (err) {
      console.error(err);
    }
  }

  async clearData() {
    if (this.editing && this.noReload) await this.getForm();
    this.editing = undefined;
  }

  async setForm({ product, action, changeAction }) {
    try {
      let msg = '';
      this.noReload = false;
      if (this.segmentValue === 'choices') {
        msg = 'ADICIONAL';
        this.noReload = true;
      } else {
        msg = 'GRUPO';
        this.noReload = false;
      }
      const { id, savedForm } = await this.fileSv.getProduct(
        { product, action, changeAction },
        this.editing,
        this.segmentValue,
        msg.toLowerCase(),
        this.savedForm,
        this.noReload && this.editing ? 'no-reload' : 'reload'
      );
      this.editing = id;
      this.savedForm = savedForm;
      if (this.segmentValue === 'specialRequests') {
        await this.getRequest();
      } else if (this.segmentValue === 'choices') {
        const copyFieldForms = [...this.fieldForms];
        this.fieldForms = undefined;
        const indexParents = copyFieldForms.findIndex(
          (item) => item.fieldName === 'choiceId'
        );
        const backParentsCopy = { ...this.backParents };
        backParentsCopy.select = this.backParents.select.filter(
          (item) => item.id !== savedForm.id
        );
        copyFieldForms[indexParents] = backParentsCopy;
        setTimeout(() => {
          this.fieldForms = copyFieldForms;
        });
        this.savedForm.choiceId = this.savedForm.choiceId.map((item) => {
          if (Number(item)) return item;
          else return item.parentId;
        });
      }
    } catch (err) {
      await this.uiSv.loading?.dismiss();
      console.error(err);
    }
  }

  async getRequest() {
    try {
      const res: any = await this.httpSv.getProduct(
        this.savedForm.id,
        'specialRequests'
      );
      this.group = res;
    } catch (err) {
      console.error(err);
    }
  }
}
